<template>
    <nav class="mainNavigation" >
    <div class="layout-w" >
      <div class="menu-mobile menu-activated-on-click color-scheme-dark">
          <div class="mm-logo-buttons-w">
              <span>{{allTemplateDetails.name}}</span>
            <div class="mm-buttons">
              <div class="content-panel-open">
                <div class="os-icon os-icon-grid-circles"></div>
              </div>
              <div class="mobile-menu-trigger">
                <div class="os-icon os-icon-hamburger-menu-1"></div>
              </div>
            </div>
          </div>
          <div class="menu-and-user">
            <div class="logged-user-w">
              <div class="logged-user-info-w">
                <div class="logged-user-name">
                  {{getUserDetails.name}}
                </div>
                <div class="logged-user-role">
                  {{currentLevel}}
                </div>
              </div>
            </div>
            <!--------------------
            START - Mobile Menu List
            -------------------->
            <ul class="main-menu">
              <li>
                <router-link :to="{ name: 'profile' }">
                  <div class="icon-w">
                    <div class="os-icon os-icon-user"></div>
                  </div>
                  <span>{{ t('navProfile','navProfile') }}</span>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'portal' }" class="colour-hover">
                  <div class="icon-w">
                    <div class="os-icon os-icon-home colour-nav-text"></div>
                  </div>
                  <span class="colour-nav-text">{{ t('navHome', 'navHome') }}</span>
                </router-link>
              </li>
              <li :class="{'has-sub-menu': countKeys(navbar.menu) > 0}" v-for="(navbar, key) in getUserDetails.navbar" v-bind:key="navbar.id">
                <a href="#" class="colour-hover">
                  <div class="icon-w">
                    <div class="os-icon colour-nav-text" v-bind:class="navbar.navbar_icon"></div>
                  </div>
                  <span class="colour-nav-text">{{ t(key,key) }}</span>
                </a>
                <div class="sub-menu-w" >
                  <div class="sub-menu-i">
                    <ul class="sub-menu" v-for="item in navbar.menu" v-bind:key="item.id">
                        <li v-for="nav in item" v-bind:key="nav.id">
                          <router-link :to="{ name: nav.item_name }" class="sub-menu-text">{{ t(nav.item_key,nav.item_key) }}</router-link>
                        </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li>
                <a v-on:click="logOut" href="javascript:void(0)">
                  <div class="icon-w">
                    <div class="os-icon os-icon-signs-11"></div>
                  </div>
                  <span> {{t('logoutKey', 'logoutKey')}}</span>
                </a>
              </li>
            </ul>
            <!--------------------
            END - Mobile Menu List
            -------------------->
          </div>
        </div>
        <div class="navbar-background-image menu-w color-scheme-dark color-style-bright menu-position-top menu-layout-compact sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-with-image menu-has-selected-link" :class="{colourHeaderBg : !hasHeaderImage}" v-bind:style="{ backgroundImage: 'url(' + allTemplateDetails.navbarBackgroundImage + '),  linear-gradient(to top, #00c6fb 0%, #005bea 100%)' }" style="background-attachment: initial; background-size: cover; background-position: center center;">
            <div class="logo-w">
             <router-link  v-if="allTemplateDetails.show_newsnet" class="logo" to="portal">
                <div class="logo-label">
                  Powered by Corcentric
                </div>
              </router-link>
            </div>
           <div class="logged-user-w avatar-inline">
            <div class="logged-user-i">
              <div class="avatar-w">
                <img v-if="getUserDetails.profilePicture" :src="getUserDetails.profilePicture + '?' + this.cacheValue" class="user-pic" alt="profile picture">
                <i v-else class="os-icon os-icon-user-male-circle2" v-bind:style="{ color: allTemplateDetails.profileIconColour}"></i>
              </div>
              <div class="logged-user-info-w"></div>
              <div class="logged-user-toggler-arrow">
                <div class="os-icon os-icon-chevron-down"></div>
              </div>
              <div class="logged-user-menu color-style-bright">
                <div class="logged-user-avatar-info">
                  <div class="avatar-w">
                    <img v-if="getUserDetails.profilePicture" :src="getUserDetails.profilePicture + '?' + this.cacheValue" class="user-pic" alt="profile picture">
                    <i v-else class="os-icon os-icon-user-male-circle2" v-bind:style="{ color: allTemplateDetails.profileIconColour}"></i>
                  </div>
                  <div class="logged-user-info-w">
                    <div v-if="getUserDetails.name" class="logged-user-name">{{getUserDetails.name}}</div>
                    <!--<div v-else-if="getUserDetails.username" class="logged-user-role">{{getUserDetails.username}}</div>-->
                    <div if="getUserDetails.email" class="logged-user-role">{{getUserDetails.email}}</div>
                  </div>
                </div>
                <div class="bg-icon">
                  <i class="os-icon os-icon-wallet-loaded"></i>
                </div>
                <ul>
                  <li>
                    <UserLevel v-if="getIsNewsnet" />
                  </li>
                  <li>
                    <router-link :to="{ name: 'profile' }"><i class="os-icon os-icon-user"></i><span>{{ t('navProfile','navProfile') }}</span></router-link>
                  </li>
                  <li v-if="getIsNewsnet && businessUnitSet">
                    <a href="javascript:void(0)" @click="resetBusinessUnit()"><i class="os-icon os-icon-home"></i><span>{{ t('resetBuBtnText','resetBuBtnText') }}</span></a>
                  </li>
                  <!-- EIPP-602, V1 Redirection link, PW -->
                  <li v-if="getUserDetails.v1_redirection">
                    <a href="javascript:void(0)" @click="redirectToV1()"><i class="os-icon os-icon-home"></i><span>{{ t('redirectToClassicView','redirectToClassicView') }}</span></a>
                  </li>
                  <li>
                    <a v-on:click="logOut" href="javascript:void(0)"><i class="os-icon os-icon-signs-11"></i><span>{{t('logoutKey', 'logoutKey')}}</span></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <h1 class="menu-page-header"><img :src="allTemplateDetails.navbarLogoImage + '?' + this.cacheValue" :alt="allTemplateDetails.name" /></h1>
          <ul class="main-menu colour-nav-bg">
            <li>
              <router-link :to="{ name: 'portal' }" class="colour-hover">
                <div class="icon-w">
                  <div class="os-icon os-icon-home colour-nav-text"></div>
                </div>
                <span class="colour-nav-text">{{ t('navHome', 'navHome') }}</span>
              </router-link>
            </li>
            <li :class="{'has-sub-menu': countKeys(navbar.menu) > 0}" v-for="(navbar, key) in getUserDetails.navbar" v-bind:key="navbar.id">
              <a v-if="countKeys(navbar.menu) > 0" class="colour-hover ">
                <div class="icon-w">
                  <div class="os-icon colour-nav-text" v-bind:class="navbar.navbar_icon"></div>
                </div>
                <span class="colour-nav-text">{{ t(key,key) }}</span>
              </a>
              <router-link v-else :to="{ name: navbar.item_name }" class="colour-hover ">
                <div class="icon-w">
                  <div class="os-icon colour-nav-text" v-bind:class="navbar.navbar_icon"></div>
                </div>
                <span class="colour-nav-text">{{ t(key,key) }}</span>
              </router-link>
              <div class="sub-menu-w" >
                <div class="sub-menu-icon">
                  <i class="os-icon" v-bind:class="navbar.navbar_bg_icon"></i>
                </div>
                <div class="sub-menu-i">
                  <ul class="sub-menu" v-for="item in navbar.menu" v-bind:key="item.id">
                      <li v-for="nav in item" v-bind:key="nav.id">
                        <router-link v-if="nav.item_name != 'disputes'" :to="{ name: nav.item_name }" class="sub-menu-text">{{ t(nav.item_key,nav.item_name) }}</router-link>
                        <router-link v-else-if="nav.item_name == 'disputes' && disputesEnabled" :to="{ name: nav.item_name }" class="sub-menu-text">{{ t(nav.item_key,nav.item_name) }}</router-link>
                      </li>
                  </ul>
                </div>
              </div>
            </li>
            <NavbarLanguages ref="navbarLang"/>
            <!--<li v-if="getUserDetails.v1_redirection">
              <a href="javascript:void(0)" @click="redirectToV1()"><i class="os-icon os-icon-home"></i><span>{{ t('redirectToClassicView','redirectToClassicView') }}</span></a>
            </li>-->
          </ul>
        </div>
    </div>
    </nav>
</template>

<script>
import NavbarLanguages from '@/components/NavbarLanguages.vue'
import UserLevel from '@/components/UserLevel.vue'
import { mapGetters} from 'vuex'

export default {
  name: 'Navbar',
  components: {
    UserLevel,
    NavbarLanguages
  },
  data() {
      return {
          currentLevel: localStorage.getItem('userLevelName') || 'Newsnet',
          cacheValue: new Date().getTime(),
          hasHeaderImage: false,
          isBusy: false
      }
  },
  methods: {
    resetBusinessUnit() {
      this.$store.dispatch('resetBusinessUnit').then(() => {
        this.update()
      }, this)
    },
    logOut(){
      this.$store.dispatch('logOut')
    },
    applyBackground(){
      let navBar = document.getElementsByClassName('navbar-background-image')
      //navBar[0].style.backgroundImage = "url("+this.$store.getters.allTemplateDetails.navbarBackgroundImage+ '?' + this.cacheValue+"),  linear-gradient(to top, #00c6fb 0%, #005bea 100%)"
      if(this.$store.getters.allTemplateDetails.navbarBackgroundImage){
        this.hasHeaderImage = true
      }
      document.body.style.backgroundImage = "none"
    },
    countKeys(item){
      var size = 0, key;
      for (key in item) {
          if (item.hasOwnProperty(key)) size++;
      }
      return size;
    },
    update() {
      this.cacheValue = new Date().getTime()
      let navBar = document.getElementsByClassName('navbar-background-image')
      if(this.$store.getters.allTemplateDetails.navbarBackgroundImage) {
        navBar[0].style.backgroundImage = "url("+this.$store.getters.allTemplateDetails.navbarBackgroundImage+ '?' + this.cacheValue+"),  linear-gradient(to top, #00c6fb 0%, #005bea 100%)"
      }
    },
    os_init_sub_menus() {
      //DropDownMenu
      ////****David fixed it. When time permits we need to stop using JQuery****////
      let menu_timer;
      $('.menu-activated-on-hover').on('mouseenter', 'ul.main-menu > li.has-sub-menu', function () {
          var $elem = $(this);
          clearTimeout(menu_timer);
          $elem.closest('ul').addClass('has-active').find('> li').removeClass('active');
          $elem.addClass('active');
      });

      $('.menu-activated-on-hover').on('mouseleave', 'ul.main-menu > li.has-sub-menu', function () {
          var $elem = $(this);
          menu_timer = setTimeout(function () {
            $elem.removeClass('active').closest('ul').removeClass('has-active');
          }, 30);
      });
      $('.menu-activated-on-click').on('click', 'li.has-sub-menu > a', function (event) {
        var $elem = $(this).closest('li');
        if ($elem.hasClass('active')) {
          $elem.removeClass('active');
        } else {
          $elem.closest('ul').find('li.active').removeClass('active');
          $elem.addClass('active');
        }
        return false;
      });
      $('.mobile-menu-trigger').on('click', function () {
         $('.menu-mobile .menu-and-user').slideToggle(200, 'swing');
         return false;
      });

    },
    // EIPP-602 Added link for redirection to V1, PW
    redirectToV1() {
      if(this.$route.meta) {
        if(this.$route.meta.destination) {
          this.$store.dispatch('redirectToV1', this.$route.meta.destination)
        }
      }

      this.$store.dispatch('redirectToV1', '')
    }
  },
  computed:{
    ...mapGetters(['getUserDetails', 'getSpinner','getIsNetsendUser','getIsNewsnet','allTemplateDetails']),
    disputesEnabled() {
      if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.scf_enabled && ((this.$store.getters.getUserDetails && this.$store.getters.getUserDetails.user_scf_customer) || this.$store.getters.getUserLevel > 0.00 )) {
          return true
      }

      return false
    },
    businessUnitSet() {
      if(localStorage.getItem('clientConfig')) {
        return true
      }

      return false
    }
  },
  created(){
    if (!this.getUserDetails.id && !this.isBusy) {
        this.isBusy = true
        this.$store.dispatch('loginWithToken').then(() => {
          this.isBusy = false
        })
    }
  },
  mounted() {
    this.os_init_sub_menus()
    this.applyBackground()
  }
}


</script>

<style scoped>
  .middle{
    width: 240px;
  }
  .avatar-w{
    border: none !important;
  }
  .avatar-w i{
    font-size: 30px;
  }
  .logged-user-name{
    text-transform: capitalize;
  }
  .menu-page-header{
    text-transform: uppercase;
  }
  .logo-w .logo-label, .logged-user-w, .white-color{
    color: #fff;
  }
  /*for testing only*/
  .imageTest{
      position:absolute;
      top:5%;
      left:1%;
      width: 700px;
      height: 150px;
      display: inline-block;
  }
  .user-pic {
    width: 30px;
    height: 30px;
    max-width: 100%;
  }
  .menu-page-header > img {
    max-height: 130px;
  }
</style>
